import React from "react";
import { Redirect } from "react-router-dom";

// Created By Cursor — merged into LeaveManagement (student + staff)
export default function LeaveManagementAdmin() {
  return <Redirect to="/AdminMain/LeaveManagement" />;
}
